!function() {
  "use strict";
  customElements.get("vanilla-slider") || customElements.define("vanilla-slider", class extends HTMLElement {
    index=0;
    slider=this.querySelector("[data-slider]");
    slides=this.querySelectorAll("[data-slide]");
    prev=this.querySelectorAll("[data-prev]");
    next=this.querySelectorAll("[data-next]");
    nav=this.querySelectorAll("[data-nav]");
    autoplay=1e3 * this.dataset.autoplay || 0;
    thumbnails=this.querySelector("[data-thumbnails]");
    progress=this.querySelector("[data-progress]");
    scrollbar=this.querySelector("[data-scrollbar]");
    hide=this.hasAttribute("data-hide");
    trackNavigation=JSON.parse(this.getAttribute("data-track-navigation")) || !1;
    timeout;
    scroll(t) {
      let e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
      if (e && (e.preventDefault(), e.stopPropagation()), this.hasAttribute("data-vertical")) "left" == t ? this.goTo(Math.max(0, this.index - 1)) : this.goTo(Math.min(this.slides.length - 1, this.index + 1)); else {
        let e = (this.slides[this.index || 0] || this.slider).offsetWidth, s = this.slider.scrollLeft;
        this.slider.scrollTo({
          left: "left" == t ? s - e : s + e,
          behavior: "smooth"
        });
      }
      if (!this.trackNavigation || !this.trackNavigation?.event_name) return;
      const s = {
        event: this.trackNavigation.event_name,
        direction: t
      };
      this.trackNavigation.event_property && (s[this.trackNavigation.event_property] = this.trackNavigation.event_value), 
      window.dataLayer = window.dataLayer || [], window.dataLayer.push(s);
    }
    goTo(t) {
      let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "smooth";
      if (this.hasAttribute("data-vertical") && window.innerWidth > 1024) {
        let s = (this.slides[t] || this.slider).clientHeight;
        this.slider.scrollTo({
          top: s * parseInt(t),
          behavior: e
        });
      } else {
        let s = (this.slides[t] || this.slider).clientWidth;
        this.slider.scrollTo({
          left: s * parseInt(t),
          behavior: e
        });
      }
    }
    hideArrow=t => {
      this.hide && t.classList.add("opacity-0"), t.classList.add("text-subdued"), t.classList.add("pointer-events-none"), 
      t.classList.remove("text-links"), t.classList.remove("pointer-events-auto");
    };
    showArrow=t => {
      this.hide && t.classList.remove("opacity-0"), t.classList.remove("text-subdued"), 
      t.classList.remove("pointer-events-none"), t.classList.add("text-links"), t.classList.add("pointer-events-auto");
    };
    updateIndex() {
      if (this.autoplay && clearTimeout(this.timeout), this.hasAttribute("data-vertical")) {
        var t = this.index, e = window.innerHeight + 1;
        if (this.slider.scrollTop <= 0) t = 0; else if (this.slider.scrollTop + e >= this.slider.scrollHeight) t = this.slides.length - 1; else for (var s = 0, i = this.slides.length; s < i; s++) this.slides[s].getBoundingClientRect().y > -10 && this.slides[s].getBoundingClientRect().top < e && (t = s);
      } else {
        t = this.index;
        var r = window.innerWidth + 1;
        if (this.slider.scrollLeft <= 0) t = 0; else if (this.slider.scrollLeft + r >= this.slider.scrollWidth) t = this.slides.length - 1; else for (s = 0, 
        i = this.slides.length; s < i; s++) this.slides[s].getBoundingClientRect().x > -5 && this.slides[s].getBoundingClientRect().right < r && (t = s);
      }
      this.index = t;
    }
    updateArrows() {
      setTimeout((() => {
        this.hasAttribute("data-vertical") ? (this.slider.scrollTop > 0 ? this.prev.forEach(this.showArrow) : this.prev.forEach(this.hideArrow), 
        this.index < this.slides.length - 1 ? this.next.forEach(this.showArrow) : this.next.forEach(this.hideArrow)) : (this.slider.scrollLeft > 0 ? this.prev.forEach(this.showArrow) : this.prev.forEach(this.hideArrow), 
        this.slider.scrollLeft + this.slider.offsetWidth < this.slider.scrollWidth - parseInt(getComputedStyle(document.documentElement).getPropertyValue("--spacing-offset")) ? this.next.forEach(this.showArrow) : this.next.forEach(this.hideArrow));
      }), 100);
    }
    updateNav() {
      let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "smooth";
      this.nav.forEach((e => {
        e.querySelectorAll("button").forEach(((s, i) => {
          e.hasAttribute("data-thumbnails") ? i === this.index ? (s.classList.remove("opacity-50"), 
          s.scrollIntoView({
            block: "center",
            behavior: t
          })) : s.classList.add("opacity-50") : this.autoplay ? i === this.index ? (s.classList.remove("[&>span]:duration-300", "justify-end"), 
          s.classList.add("[&>span]:w-full")) : (s.classList.add("[&>span]:duration-300", "justify-end"), 
          s.classList.remove("[&>span]:w-full")) : i === this.index ? (s.classList.add("opacity-100"), 
          s.classList.remove("opacity-30")) : (s.classList.add("opacity-30"), s.classList.remove("opacity-100"));
        }));
      }));
    }
    updateProgress() {
      let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.slider.scrollLeft;
      if (!this.progress) return;
      const e = Math.min(1, t / (this.slider.scrollWidth - this.slider.clientWidth)) || 0;
      this.style.setProperty("--progress-decimal", e), this.style.setProperty("--progress", 100 * e + "%");
    }
    update() {
      this.updateIndex(), this.updateArrows(), this.nav && this.updateNav(), this.progress && this.updateProgress();
    }
    constructor() {
      super();
    }
    connectedCallback() {
      if (!this.slider) return !1;
      if (window.index && this.goTo(window.index, "instant"), this.prev.forEach((t => t.addEventListener("click", (t => this.scroll("left", t))))), 
      this.next.forEach((t => t.addEventListener("click", (t => this.scroll("right", t))))), 
      this.nav && this.nav.forEach((t => {
        t.querySelectorAll("button").forEach(((t, e) => {
          t.addEventListener("click", (() => this.goTo(e)));
        }));
      })), this.update(!0), this.slider.addEventListener("scroll", (() => this.update()), {
        passive: !0
      }), this.progress && (this.progress.style.setProperty("--items", this.slides.length), 
      this.progress.addEventListener("click", (t => {
        try {
          this.goTo(Math.round((this.slides.length - Math.floor(this.slider.clientWidth / (this.slides[this.index || 0] || this.slider).clientWidth)) * (t.layerX / t.target.clientWidth)));
        } catch (t) {
          console.warn("Progress click error: " + t);
        }
      }))), this.scrollbar && (this.style.setProperty("--height", (window.visualViewport.height || window.innerHeight) / this.clientHeight * 100 + "%"), 
      window.addEventListener("scroll", (() => {
        const t = this.getBoundingClientRect(), e = Math.abs(t.y - [ ...document.querySelectorAll(".shopify-section-group-header-group") ].reduce(((t, e) => t + e.clientHeight), 0)) / (t.height + (window.visualViewport.height || window.innerHeight) / 2) * 100;
        this.style.setProperty("--top", `${e}%`);
      }), {
        passive: !0
      })), this.autoplay) {
        let t = 0;
        const e = setInterval((() => {
          t = t == this.slides.length - 1 ? 0 : t + 1, this.goTo(t);
        }), this.autoplay);
        [ "wheel", "touchmove", "click" ].forEach((t => {
          this.addEventListener(t, (() => {
            clearInterval(e);
          }), {
            passive: !0
          });
        }));
      }
      new MutationObserver(((t, e) => {
        this.slides = this.querySelectorAll("[data-slide]"), this.progress?.style.setProperty("--items", this.slides.length), 
        this.update();
      })).observe(this.slider, {
        childList: !0,
        subtree: !1,
        characterData: !1,
        attributes: !1
      }), this.closest(".shopify-section")?.addEventListener("input", (() => {
        this.update();
      })), this.addEventListener("goto", (t => {
        this.index = parseInt(t.detail.index), this.updateNav("instant"), this.goTo(this.index, "instant");
      }));
    }
  });
}();